export * from './patient-distribution';
export * from './table-data';
export * from './patient-distribution-administrative-district';
export * from './patient-distribution-postal-code';
